import React, { useEffect } from 'react';
import * as THREE from "three";
import {GLTFLoader} from "three/addons/loaders/GLTFLoader.js"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useState } from 'react';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import LoadingCarpet from '../../common/LoadingCarpet';


const PitcureTest = () => {
    //TODO: All state
  const [playLoading,setPlayLoading] = useState(true);
  const [pixelDensity,] = useState(1);
 
  const refCanvas = useRef(null);

  const [scene,] = useState(new THREE.Scene());
  const [moveMouse,] = useState(new THREE.Vector2());
  const [clickMouse,] = useState(new THREE.Vector2());

  const [renderRatio, setRenderRatio] = useState({});
  const [marginTB,setMarginTB] = useState(0);
  const [marginLR,setMarginLR] = useState(0);

  const ref_rendet_ratio = useRef(null);

  
  const dataOfCanvas = useSelector(state => state.picture);
  const {floor,other,fov,angle,position, width, height} = dataOfCanvas;
  useEffect(() => {
    const img = new Image();
    img.src = floor;
    img.onload = () => {
      setRenderRatio({
          width: ref_rendet_ratio.current.clientWidth,
          height: ref_rendet_ratio.current.clientHeight,
      })
    }
  },[floor]);

  useEffect(() => {
      //Horizental image
      if ((width / height) >= (renderRatio.width / renderRatio.height)) {
          let margin_tb = renderRatio.height - ((renderRatio.width / width) * height);
          setMarginTB(margin_tb);
          setMarginLR(0)
      }else{
      //Vertical Image
          let margin_lr = renderRatio.width - ((renderRatio.height / height) * width);
          setMarginLR(margin_lr)
          setMarginTB(0)
      }
      
      
  },[renderRatio]);
 
  //   -------------------------------------------
  const params_texture = useSelector(state => state.paramsOfTexture);
  const position_carpet = useSelector(state => state.resetPositionCarpet);
  const secondCarpet = useSelector(state => state.secondCarpet);
  const carpet_size = useSelector(state => state.sizeChange);

  let frame_counter = useRef(0);
  let start_postion = useRef({});
  const mouse_start_position = useRef({});


  let mouse_stack = useRef([]);
  
  let first_scale = useRef(null);
  let second_scale = useRef(null);

  let distance = useRef(new THREE.Vector3());
  let draggable = useRef(null);
  let draggable_position = useRef(null);
  let draggable_rotation = useRef(null);

  let counter = useRef(0);
  let status = useRef(false);
  
  let move = useRef(null);
  let rotate = useRef(null);

  const renderer = useRef(null);
  const rect = useRef(null);

  const loadingManager = new THREE.LoadingManager();
  var mapback,mapfront;
  
  useEffect(() => {
    setPlayLoading(true);
    loadingManager.onLoad = () => {
      frame_counter.current += 1
      setupScene();
      setTimeout(() => {
        setPlayLoading(false);
      },2000)
    };
  
    const textureLoader = new THREE.TextureLoader();
    textureLoader.manager = loadingManager;
    // Load textures of sprits with textureLoader

    mapback = textureLoader.load(floor);
    mapfront = textureLoader.load(other);
  }, [floor,other]);
  

  const start_postion_finder = () => {
    if (rect.current){
      let cnv = document.getElementById('myCanvas');
      const canvas_width = cnv.clientWidth
      const canvas_height = cnv.clientHeight
      
      const x_start = (position.x * (canvas_width- marginLR) / width) + marginLR/2
      const y_start = (position.y * (canvas_height - marginTB) / height) + marginTB/2

      const xRatio = (x_start / (renderRatio.width - marginLR)) - (marginLR / (renderRatio.width - marginLR)) / 2;
      mouse_start_position.current.x = xRatio * 2 - 1; 
      const yRatio = -(y_start / (renderRatio.height - marginTB)) + (marginTB / (renderRatio.height - marginTB)) / 2;
      mouse_start_position.current.y = yRatio * 2 + 1; 
    }
  };


  const camera = useRef(null);
  useEffect(() => {
    camera.current = new THREE.PerspectiveCamera(
      fov,
      width / height,
      0.01,
      30000
    );
    camera.current.position.set(0, 1.5, 2.5);
    camera.current.rotation.set( -(angle * Math.PI / 180), 0, 0);
  },[angle, fov, height, width])


  useEffect(() => {
    renderer.current = new THREE.WebGLRenderer({
    canvas: refCanvas.current,
    preserveDrawingBuffer: true,
    alpha: false,
    antialias: true,
    precision: "highp",
    powerPreference: "high-performance",
    })
    THREE.ColorManagement.enabled = true;
    renderer.current.outputColorSpace = THREE.LinearSRGBColorSpace;
    rect.current = renderer.current.domElement.getBoundingClientRect();
    renderer.current.setSize(width, height);

  },[height, width]);


  const setupScene = () => {
    renderer.current.shadowMap.enabled = true;
    renderer.current.shadowMap.type = THREE.PCFSoftShadowMap;
    renderer.current.setPixelRatio(window.devicePixelRatio * pixelDensity); // Increase pixel ratio
    if (!scene.getObjectByName("plane")){
      const planeGeometry = new THREE.PlaneGeometry(50, 50); // Width, Height
      const plane_material = new THREE.MeshBasicMaterial({
        color: 0x6e6e6e,
        transparent: true,
        opacity: 0,
      }); 
      // Create mesh using planeGeometry & plane_material
      const plane = new THREE.Mesh(planeGeometry, plane_material);
      // Rotate the plane to be orthogonal to the floor
      plane.rotation.x = -Math.PI / 2;
      plane.position.y = -0.01;
      plane.name = "plane";
      plane.userData.draggable = false;
      plane.userData.ground = true;
      plane.userData.untouch = true;
      // Add plane to the scene
      scene.add(plane);

      // const raycaster = new THREE.Raycaster();
      // raycaster.setFromCamera(mouse_start_position.current, camera.current);
      // const found = raycaster.intersectObjects(scene.children);
      // // console.log('found', found);
      // for (let o of found) {
      //   if (o.object.name == 'plane'){
      //     start_postion.current = o.point;
      //     // console.log('start_postion', start_postion.current);
      //   }
      // }
      // if (draggable.current){
      //   // console.log('position set');
      //   draggable.current.position.set(start_postion.current.x, start_postion.current.y, start_postion.current.z)
      // }

    }

    if(scene.getObjectByName("spritefront") && scene.getObjectByName("spriteback")){
      scene.remove(scene.getObjectByName("spritefront"));
      scene.remove(scene.getObjectByName("spriteback"));
      scene.remove(scene.getObjectByName("spriteback").parent);
    }
    if (!scene.getObjectByName("spritefront") && !scene.getObjectByName("spriteback")){
    const sprits_group = new THREE.Group();
    let aspect_ratio = width / height;
  
    //camera to fisrt sprit distance
    let first_sprit_distance = Math.abs(3.5 / Math.cos(-(angle * Math.PI / 180)));
    let scale = 2 * first_sprit_distance * Math.tan((Math.PI * (fov / 2)) / 180);
    let spritback_pos = 1.5 + 27.5 * Math.tan(-(angle * Math.PI / 180));
    let spritfront_pos = 1.5 + 3.5 * Math.tan(-(angle * Math.PI / 180));

    var materialback = new THREE.SpriteMaterial({ map: mapback, color: 0xffffff });
    var spriteback = new THREE.Sprite(materialback);
    spriteback.scale.set(
      (27.5 / 3.5) * scale * aspect_ratio,
      (27.5 / 3.5) * scale,
      1
    );
    spriteback.position.set(0, spritback_pos, -25);
    spriteback.rotation.set(Math.PI / 2, 0, 0);
    spriteback.name = "spriteback";
    spriteback.userData.untouch = true;
    sprits_group.add(spriteback);
  
    var materialfront = new THREE.SpriteMaterial({
      map: mapfront,
      color: 0xffffff,
      transparent: true,
      opacity: 0.95,
    });
    var spritefront = new THREE.Sprite(materialfront);
    spritefront.scale.set(scale * aspect_ratio, scale, 1);
    spritefront.position.set(0, spritfront_pos, -1);
    spritefront.rotation.set(Math.PI / 2, 0, 0);
    spritefront.name = "spritefront";
    spritefront.userData.untouch = true;
    materialfront.depthTest = false;
    sprits_group.add(spritefront);
    scene.add(sprits_group);
    }
    
    // Create ambient light if it does not exist in scene
    if (!scene.getObjectByName("ambient_light")){
    const ambient_light = new THREE.AmbientLight(0xffffff, 0.5);
    ambient_light.name = 'ambient_light'
    scene.add(ambient_light);
    }

    // Create directional light if it does not exist in scene
    if (!scene.getObjectByName("directional_light")){
    const directional_light = new THREE.DirectionalLight(0xffffff, 0.5);
    directional_light.name = 'directional_light'
    directional_light.position.set(1, 1, 1);
    scene.add(directional_light);
    }
    renderer.current.render(scene, camera.current);
  };

  const loadModel = (first, draggable_position) => {

    let model = new THREE.Object3D();
    // Load the GLB model
    const loader = new GLTFLoader(loadingManager);
    setPlayLoading(true);
    loader.load(`https://api.ariisco.com/media/models/${params_texture}.glb`,
        function (gltf) {
            // Access the loaded object
            model = gltf.scene;
            model.scale.set(1, 1.5, 1);
          

            // if (scene.children.length> 0){
            //   const raycaster = new THREE.Raycaster();
            //   raycaster.setFromCamera(mouse_start_position.current, camera.current);
            //   // const plane = scene.getObjectByName("plane")
              
            //   const found = raycaster.intersectObjects(scene.children);
            //   // console.log('found', found);
            //   for (let o of found) {
            //     if (o.object.name == 'plane'){
            //       // console.log('o.object.name', o.object.name);
            //       start_postion.current = o.point;
                
            //       // console.log('start_postion', start_postion.current);
            //     }
            //   }
            //   model.position.set(start_postion.current.x, start_postion.current.y, start_postion.current.z)
            // }
            
            
            if (draggable_position) {
              model.position.set(draggable_position.x, draggable_position.y, draggable_position.z)
            }
            model.children[0].userData.draggable = true;
            model.children[0].renderOrder = 1;
            model.children[1].userData.draggable = true;
            if (first) {
              model.name = 'first';
              first_scale.current =  model.scale.clone()
            }else {
                model.name = 'second'
                second_scale.current =  model.scale.clone()
                model.position.y = 0.01;
            }
            draggable.current = model;
            scene.add(model);
        },
        undefined,
        function (error) {
        // Called if there's an error loading the model
        console.error("Error loading GLB model:", error);
        }
    );

  }
  
  useEffect(() => {
    if (draggable.current) {
      const current_size = carpet_size.current_size
      const current_size_array = current_size.split('x');
      const current_size_width = parseFloat(current_size_array[0]);
      const current_size_height = parseFloat(current_size_array[1]);

      const main_size = carpet_size.main_size
      const main_size_array = main_size.split('x');
      
      const main_size_width = parseFloat(main_size_array[0]);
      const main_size_height = parseFloat(main_size_array[1]);

      const nesbat_w = main_size_width/ current_size_width  
      const nesbat_h = main_size_height/ current_size_height 

      draggable.current.scale.set(first_scale.current.x * nesbat_w, first_scale.current.y, first_scale.current.z * nesbat_h)
  
    }
  },[carpet_size]);

  useEffect(() => {
    const positionReset = () => {
      let y_posistion = 0;
      if (draggable.current.name === "second") y_posistion = 0.01
      if (draggable.current) {
        draggable.current.position.x = 0;
        draggable.current.position.z = -2;
        draggable.current.position.y = y_posistion
      }
    }
    if (draggable.current) {
      positionReset();
    }
  },[position_carpet]);

  
  const addSecondModel = () => {
    const first = false
    let model = scene.getObjectByName( "first" );
    let second_model = scene.getObjectByName("second")
    if (((first && !model) || (!first && !second_model)) && model){
      loadModel(first, draggable_position.current)
      // console.log("SecendModel");
    }
    if (model) model.children[0].visible = false;
  }
  function removeSecondModel() {
    let second_model = scene.getObjectByName("second")
    scene.remove(second_model);
  }

  useEffect(() => {
    if (secondCarpet) {
      addSecondModel()
    }
    removeSecondModel()
  },[secondCarpet])


  const dragObject = () => {
    const raycaster = new THREE.Raycaster() 

    if (draggable.current != null) {
      raycaster.setFromCamera(moveMouse,camera.current);
      const found = raycaster.intersectObjects(scene.children);
      if (found.length > 0) {
        for (let o of found) {
          if (!o.object.userData.ground) continue;

          // code for moving carpet and ring
          if (move.current) {
            draggable.current.position.z -= distance.current.z - o.point.z;
            draggable.current.position.x -= distance.current.x - o.point.x;
          }
          // store last position of ray
          distance.current = o.point;
          
          // code for rotating carpet and it's ring
          // tranfer coordinate system origin to center of carpet
          let x_shif = o.point.x + draggable.current.position.x;
          let z_shift = o.point.z + draggable.current.position.z;
  
          // stacking 4 points of mouse is good and enough for rotating
          mouse_stack.current.push({ x: x_shif, z: z_shift });
          if (mouse_stack.current.length > 4) {
            mouse_stack.current.shift();
          }
        
          if (rotate.current) {
              // calculate approximate value for rotating
              // the value calculateed from first and last mouse position
            let x_rotate = (mouse_stack.current[mouse_stack.current.length - 1].x - mouse_stack.current[0].x) / 5;
            let z_rotate = (mouse_stack.current[mouse_stack.current.length - 1].z - mouse_stack.current[0].z) / 5;
    
              // there are four state because of  four coordinate regions by 2 state foreach of x & z
            if (o.point.x - draggable.current.position.x < 0) {
              if (o.point.z - draggable.current.position.z < 0) {
                draggable.current.rotation.y += -x_rotate + z_rotate;
              } else {
                draggable.current.rotation.y += x_rotate + z_rotate;
              }
            } else {
              if (o.point.z - draggable.current.position.z < 0) {
                draggable.current.rotation.y += -x_rotate - z_rotate;
              } else {
                draggable.current.rotation.y += x_rotate - z_rotate;
              }
            }
          }
        }
      }
    }
  }

  // TODO mouseDown
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleMouseDown = event => {
    status.current = true;
    var model = scene.getObjectByName( "first" );
    var second_model = scene.getObjectByName( "second" );

    const raycaster = new THREE.Raycaster()
    const rect = renderer.current.domElement.getBoundingClientRect();
    
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
  
    const xRatio = (x / (renderRatio.width - marginLR)) - (marginLR / (renderRatio.width - marginLR)) / 2;
    clickMouse.x = xRatio * 2 - 1; 
    const yRatio = -(y / (renderRatio.height - marginTB)) + (marginTB / (renderRatio.height - marginTB)) / 2;
    clickMouse.y = yRatio * 2 + 1; 

    // disabling mouse down ouside of canvas with restriction between 1 and -1 
    if ( -1 < clickMouse.x  &&  clickMouse.x < 1 && -1 < clickMouse.y  &&  clickMouse.y < 1) {
      raycaster.setFromCamera(clickMouse, camera.current);
      const found = raycaster.intersectObjects(scene.children);
      
      if (found.length > 0) {
        
        for (var i = 0; i < found.length; i++) {
          if (!found[i].object.userData.untouch) {
            if (found[i].object.name === "carpet") {
              move.current = true;
              draggable.current = found[i].object.parent;
              draggable.current.children[0].visible = true;
    
              if (draggable.current.name === "first") {
                if (second_model && second_model.children.length > 0) {
                  second_model.children[0].visible = false;
                }
              } else {
                if (model.children.length > 0) {
                  model.children[0].visible = false;
                }
              }
            }
    
            if (found[i].object.name === "Torus001") {
              mouse_stack.current = [];
              rotate.current = true;
              draggable.current = found[i].object.parent;
              if (draggable.current.name === "first") {
                
                if (second_model && second_model.children.length > 0) {
                  second_model.children[0].visible = false;
                }
              } else {
                if (model.children.length > 0) {
                  model.children[0].visible = false;
                }
              }
              draggable.current.children[0].visible = true;
            }
            break;
          } else {
            if (found[i].object.userData.untouch) {
              if (model.children.length > 0) {
                model.children[0].visible = false;
              }
              if (second_model && second_model.children.length > 0) {
                second_model.children[0].visible = false;
              }
            }
          }
        }
      }
    }
    // hide rings if mouse clicked outside of canvas
    else {
      if (model) model.children[0].visible = false;
      if (second_model) second_model.children[0].visible = false;
    }
  }
    
  const handleMouseMove = (event) => {
    const rect = renderer.current.domElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    const xRatio = (x / (renderRatio.width - marginLR)) - (marginLR / (renderRatio.width - marginLR)) / 2;
    moveMouse.x = xRatio * 2 - 1; 
    const yRatio = -(y / (renderRatio.height - marginTB)) + (marginTB / (renderRatio.height - marginTB)) / 2;
    moveMouse.y = yRatio * 2 + 1; 
  }
  const handleMouseUp = (event) => {
    move.current = false
    rotate.current = false
  }
  
  const animate = () => {
    requestAnimationFrame(animate);
    renderer.current.render(scene, camera.current);
    dragObject();
    // if (playLoading && frame_counter === 0) {
    //   findFirstPoint();
    //   frame_counter += 1;
    // }
  }

  if (draggable.current) {
    loadingManager.onLoad = () => {
      setPlayLoading(false);
    }
  }
  useEffect(() => {

    let first = true
    let model = scene.getObjectByName( "first" );
    let second_model = scene.getObjectByName("second");

    if (draggable.current && draggable.current.name === "first") {
      draggable_position.current =  model.position.clone();
      first = true;
      scene.remove(model);
    }
    if (draggable.current && draggable.current.name === "second") {
      draggable_position.current =  second_model.position.clone();
      first = false;
      scene.remove(second_model);
    }
    loadModel(first, draggable_position.current);

  },[params_texture]);
  
  // useEffect(() => {
  //   getMousePositionFromPixel(pixel.x,pixel.y)

  // },[pixel]);


  useEffect(() => {
    window.addEventListener("mousemove",handleMouseMove);
    window.addEventListener("mousedown",handleMouseDown);
    window.addEventListener("mouseup",handleMouseUp);
    return () => {
      window.removeEventListener("mousemove",handleMouseMove);
      window.removeEventListener("mousedown",handleMouseDown);
      window.addEventListener("mouseup",handleMouseUp);
    }
  },[handleMouseDown, handleMouseMove])

  useEffect(() => {
    animate();
  },[])

  return (
    <>
    <div className='w-100 position-relative' style={{height:'100%'}} ref={ref_rendet_ratio}>
      {/* <Button onClick={() => positionReset()}> reset position</Button>
      <Button onClick={() => addSecondModel()}> add second carpet</Button>
      <Button onClick={() => removeSecondModel()}> remove second carpet</Button> */}
      <TransformWrapper panning maxScale={2} disablePadding>
        <TransformComponent>
          <canvas id='myCanvas' className='mx-auto' ref={refCanvas}></canvas>
        </TransformComponent>
      </TransformWrapper>
      {playLoading ? <LoadingCarpet/> : null}
    </div>
  </>
  )
}

export default PitcureTest